import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'


export default class extends React.Component {
    static propTypes = {
		slug: PropTypes.string
	};

    render() {

		return (
			<span className="text-dark-gray mright15 filters__intro">Filter articles: </span>
		)
		
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Discover/components/Filters/components/Intro.jsx